import React, { useEffect } from "react";
import "./Dashboard.scss";

import Filters from "../components/dashboard/Filters";
//import DashboardTrendsChart from "../components/dashboard/DashboardTrendsChart";


import { useAnalytics } from "../context/AnalyticsContext";
import { usePageMetadata } from "../context/PageMetadataContext";
import Statistics from "../components/dashboard/DashboardStatistics";
import GridHeader from "../components/dashboard/GridHeader";
import SortToggleButton from "../components/SortToggleButton";
import Insight from "../components/dashboard/Insight";
import { useNavigate } from "react-router-dom";
import { AppButton } from "../components/ui";

const Dashboard = () => {
  const navigate = useNavigate();

  const { insights, sortInsights, activeInsightSort, statistics } = useAnalytics();
  const { setTitle, setShowTitleInHeader } = usePageMetadata();

  useEffect(() => {
    window.scrollTo(0, 0);
    setShowTitleInHeader(true);
    setTitle("Analytics");
  }, [setShowTitleInHeader, setTitle]);

  const hasInsights = Boolean(insights && insights.length > 0);

  return (
    <div className="dashboard">
      <div className="content">
        <div className="overview-section">
          <div className="overview-header">
            <h3>Overview</h3>
            <Filters variant="compact" />
          </div>

          {statistics ? (
            <>
              <Statistics />

              {/* Visualization aligned to the same rails as Overview */}
              {/*<div className="dash-viz">
                <DashboardTrendsChart title="Activity" insights={insights || []} />
              </div>*/}
            </>
          ) : (
            <div className="dashboard-empty-state">
              <h1>Launch a new Experience to begin</h1>
              <AppButton onClick={() => navigate("/experiences")}>
                Go to Experiences
              </AppButton>
            </div>
          )}
        </div>

        {hasInsights && (
          <div className="insights-section">
            <h3>Insights</h3>

            <div className="insights-table dashboard-data-table">
              <GridHeader>
                <div className="grid-column medium">Environment</div>
                <div className="grid-column wide">Question</div>
                <div className="grid-column medium">
                  <SortToggleButton
                    attribute="responseCount"
                    sortFunction={sortInsights}
                    activeSort={activeInsightSort}
                  />
                  Completed
                </div>
                <div className="grid-column narrow">
                  <SortToggleButton
                    attribute="meanScore"
                    sortFunction={sortInsights}
                    activeSort={activeInsightSort}
                  />
                  Score
                </div>
              </GridHeader>

              <div className="insights-list app-row-list">
                {insights.map((insight) => (
                  <Insight key={insight.insightId} insight={insight} />
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Dashboard;
